import DefaultButton from './DefaultButton';

export { DefaultButton };
export default DefaultButton;
